import React from 'react';
import './FormElement.scss';

export default ({ children, label, error }) => (
	<div className="vl-form-element">
		{label && <div className="vl-form-element__label">{label}</div>}
		<div className="vl-form-element__content">{children}</div>
		{error && <div className="vl-form-element__error">{error}</div>}
	</div>
);
